// 我的直播
export default [
  {
    path: "/myLive",
    name: "myLive",
    meta: { title: "我的直播" },
    component: () => import("../views/myLive/index"),
    children: [
      {
        path: "/myLive/myLiveList",
        meta: { title: "直播列表", isMenu: true },
        component: () => import("../views/myLive/myLiveList"),
      },
    ],
  },
]
